<template>
  <div class="material">
    <div class="layout-content" style="background: transparent;">
      <Table
        :border="false"
        row-key="id"
        :columns="columns"
        :data="type"
        :load-data="handleLoadData"
        max-height='700'
      >
        <template slot-scope="{ row, index }" slot="name">{{row.name}}</template>
        <template slot-scope="{ row, index }" slot="description">{{row.Description}}</template>
        <template slot-scope="{ row, index }" slot="showIndex">{{row.showIndex}}</template>
        <template slot-scope="{ row, index }" slot="action">
          <div>
            <span style="color: #1890ff;cursor: pointer;" @click="editShow(row)">编辑</span>
            <span style="display: inline-block;padding: 0 5px;">|</span>
            <span
              style="color: #1890ff;cursor: pointer;"
              @click="editSubShow(row)"
              v-if="row.type === 1 || row.type === 2"
            >添加子项</span>
            <span
              style="display: inline-block;padding: 0 5px;"
              v-if="row.type === 1 || row.type === 2"
            >|</span>
            <Poptip confirm title="确认是否删除?" @on-ok="delItem(row)" :transfer="true">
              <span style="color: #f00;cursor: pointer;">删除</span>
            </Poptip>
          </div>
        </template>
      </Table>
    </div>
    <!-- 修改展商置顶 -->

    <supplyAdd 
      :show="show" 
      @finish="init()" 
      @close="show=false;"
      :options="options"
    />

    <!-- <proClassifyAdd :show="classify" @finish="init()" @close="classify=false;" />
    <proClassifyEdit
      :show="editClassify"
      v-if="editClassify"
      @finish="init()"
      :editInfo="editClassifyInfo"
      @close="editClassify=false;editClassifyInfo=null;"
    />
    <proClassifySubAdd
      :show="editclassifySub"
      :info="editclassifySubInfo"
      @finish="init()"
      @close="editclassifySub=false;editclassifySubInfo=null;"
    /> -->
  </div>
</template>

<script>
// import proClassifyAdd from "./components/pro-classify-add.vue";
// import proClassifySubAdd from "./components/pro-classify-sub-add";
// import proClassifyEdit from "./components/pro-classify-edit.vue";
import supplyAdd from "../components/indType-add.vue";
import { mapActions } from "vuex";

export default {
  name: "host-set-pro-category",
  data() {
    return {
      columns: [
        {
          title: "行业类别",
          key: "name",
          tree: true,
        },
        {
          title: "描述",
          key: "nameEn",
          tree: true,
        },
        {
          title: "排序",
          key: "showIndex",
          width: "100px"
        },
        {
          title: "操作",
          slot: "action",
          align: "center"
        }
      ],
      classify: false,
      editClassify: false,
      editClassifyInfo: null,
      editclassifySub: false,
      editclassifySubInfo: null,
      type: [],
      parent1: null,
      show: false, 
      options:{}, 
      modelTitle:'',
    };
  },
  components: {
    supplyAdd,
    // proClassifyAdd,
    // proClassifyEdit,
    // proClassifySubAdd
  },
  computed: {
    option() {
      return {
        ExhibitionId: this.exhibitionInfo.id,
        pageSize: this.pageSize,
        pageIndex: this.pageIndex
      };
    },
    exhibitionInfo() {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    }
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getindTypeList:'hostSetModule/getindTypeList',
      // getCategoryByExhibitionList: "categoryModule/getCategoryByExhibitionList",
      // putCategory: "categoryModule/putCategory",
      // delCategory: "categoryModule/delCategory",
      // addCategory: "categoryModule/addCategory"
    }),
    async init() {
       let url = '/api/Industry/GetListAndChildren';
      let categoryData = await this.getindTypeList(url);
      console.log(categoryData,'categoryData')
      if (categoryData && categoryData.length) {
        categoryData.map(c => {
          c.type = 1;
          c.num = c.list.length;
          if (c.num) {
            c.children = [];
            c._loading = false;
          }
        });
        this.type = categoryData;
      } else {
        this.type = [];
      }
    },
    async delItem(item) {
      let result = await this.delCategory(item.id);
      if (result.successed) {
        this.$Message.success("删除成功");
        this.init();
      } else {
        this.$Message.error("删除失败，请重新尝试");
      }
    },

    handleLoadData(item, callback) {
      const list = JSON.parse(JSON.stringify(item.list));
      list.map(c => {
        c.type = item.type + 1;
        c.num = c.list.length;
        if (c.num) {
          c.children = [];
          c._loading = false;
        }
      });
      callback(list);
    },

    showAdd() { // 新增
      this.show = true;
      this.modelTitle = '新增';
      this.options = {
        model:null,
        msg:null,
      }
    },
    editShow(item) { // 编辑
      this.show = true;
      this.modelTitle = '编辑';
      this.options = {
        model:'edit',
        msg:item,
      }
    }

    // editShow(e) {
    //   this.editClassify = true;
    //   this.editClassifyInfo = e;
    // },
    // editSubShow(e) {
    //   this.editclassifySub = true;
    //   this.editclassifySubInfo = e;
    // },
    // close() {
    //   this.classify = false;
    //   this.editClassify = false;
    //   this.editClassifyInfo = null;
    // },
    // showAdd() {
    //   this.classify = true;
    // }
  }
};
</script>

<style scoped lang="scss">
.header-tool-utils {
  margin-top: 20px;
  button {
    margin-right: 20px;
  }
}
.logo {
  width: 60px;
  height: 60px;
  display: inline-block;
}
.cate-item {
  width: 200px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; // 显示的行数
  overflow: hidden;
}
.layout-content {
  table {
  }
}
</style>

<style lang="scss">
.cate-item {
  width: 200px;
  &:hover {
    color: #1890ff;
  }
}
.cate-pop-item {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  margin-top: 6px;
  .cate-brand {
    display: inline-block;
    border: solid 1px #f0f0f0;
    background-color: #f5f5f5;
    padding: 0 6px;
    margin-right: 6px;
    margin-bottom: 6px;
    color: #333;
    :hover {
      color: #333;
    }
    &-close {
      font-size: 21px;
      position: relative;
      top: 1px;
    }
  }
}
</style>

